if (!Enum) {
    var Enum = {};
}

Enum.LEDGER_TYPE = {
    AMB: 'AMB',
    REH: 'REH',
    RTG: 'RTG',
    USG: 'USG',
    MRI: 'MRI',
    ZAB: 'ZAB'
};

Object.freeze(Enum.LEDGER_TYPE);